module.exports = "/images/icono-check.svg?cdbd4d083890b4ab078add1f6997f55d";